export const visit = (vm, at) => {
at({ "pt-br": { "pricing-pages-ui": { "phone-supportV2": { "needHelp": "Precisa de ajuda para escolher um plano?", "stillHaveQuestions": "Ainda tem d\xFAvidas sobre como o software da HubSpot pode ajudar sua empresa?" } } } });
};